export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="glass flex flex-col items-center justify-center rounded-xl px-6 py-14 text-center">
      {Icon && (
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-[rgba(85,117,245,0.10)] text-[hsl(var(--primary))]">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="font-display text-lg font-semibold">{title}</h3>
      {description && (
        <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
